import React from 'react';
import styled from 'styled-components';


import { ElevateSample, VideoDefault } from '../../../../assets/images';

const Text = styled.h1`
  position: absolute;
  top: 0;
  color: white;
  font-weight: 300;
  font-size: 36px;
  bottom: 0;
  margin: auto;
  display: flex;
  align-items: center;
  padding: 0 70px;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
  justify-content: center;
`;

const SmallText = styled(Text)`
  font-size: 26px;
`;

const ImageGradient = styled.div`
  background: radial-gradient(#323a45, #1a1f24);
  height: 100%;
  mix-blend-mode: multiply;
  opacity: 0.75;
  position: absolute;
  width: 100%;
`;

const MainBlock = styled.div`
  position: relative;
  margin: 0px auto;
  border-radius: 2px;
  overflow: hidden;
`;

const BackgroundImage = styled.img`
  display: flex;
  max-height: 500px;
  object-fit: cover;
  object-position: top;
`;







const ImagePlaceHolder = ({ sourceUrl, title, smallText }) =>
<MainBlock>
    <ImageGradient />
    <BackgroundImage
    src={sourceUrl}
    width="100%"
    alt="placeholder-video" />


    {smallText ?
  <SmallText>{title}</SmallText> :

  <Text>{title}</Text>}

  </MainBlock>;


const ElevateVideoPlaceholder = () =>
<ImagePlaceHolder
  sourceUrl={ElevateSample}
  title="Your Elevate video will appear here" />;



const SplashVideoDefaultPlaceholder = () =>
<ImagePlaceHolder
  smallText
  sourceUrl={VideoDefault}
  title="Add a video or image of your product, service or business" />;



export { ElevateVideoPlaceholder, SplashVideoDefaultPlaceholder };